<template lang="pug">
	.step
		.step__title
			|Выберите вид спорта, срок страхования, количество застрахованных и сумму на которую будет застрахован каждый участник
		.step__list
			.step__item.step__item_sports
				
				.step__item-right
					app-input(:input="schema.sports", :disabled="true", :field.sync="selectedSportsNames" @togglePopup="togglePopup")
					.input-desc
						.input-desc__title
							|Популярные:
						.input-desc__list
							.input-desc__item(v-for="sport in getInputDescription")
								a.input-desc__link(href="#", @click.prevent="selectSport(sport)")
									|{{sport.UF_NAME}}
		
			.step__item
			
						
				.step__item-right
					App-slider-input(:input="schema.term", :options="termOptions")
			.step__item
		
				.step__item-right
					App-slider-input(:input="schema.count", :options="countOptions")
			.step__item
		
				.step__item-right
					App-slider-input(:input="schema.sum", :options="sumOptions")
			.step__item
		
				.step__item-right
					app-input(:input="schema.sportClubName", :field.sync="sportClubName")
		.step__1desc
			|Размер страховой суммы - это максимальный размер выплаты при несчастном случае. Размер выплаты по конкретному случаю определяется согласно таблице выплат.
		
			.step__button
				.step__button-block
					.step__text-summ
						|Стоимость полиса {{totalCost | numeric}} ₽
				a.button(href="#", ref="buttonNext", @click.prevent="handleClick")
					|Оформить
			
		.popup-overlay(@click="togglePopup", v-if="popupIsActive")
			.popup(@click.stop)
				.popup__inner
					.popup__close(@click="togglePopup")
					.popup__title
						|Выберите из списка <br> (не более 5-ти):

					.popup__search
						input.popup__search-input(type="text", placeholder="Выберите виды спорта", v-model="searchQuery")
					.popup__list
						.popup__item(v-for="(sport, index) in filteredSportList", :class="selectedSports.indexOf(sport) != -1 ? 'active' : ''", :key="sport.ID")
							.popup__inner-item
								a.popup__link(href="#", @click.prevent="selectSport(sport)")
									|{{sport.UF_NAME}}
								.popup__remove(@click="removeSport(sport)")
					.popup__button
						a.popup__button-clear(href="#", @click.prevent="clearSelectedSports")
							|Очистить
						a.popup__button-elem(href="#", @click.prevent="togglePopup")
							|Выбрать

</template>

<script>
// @ is an alias to /src
import AppInput from '@/components/Input.vue'
import AppInputDropdown from '@/components/Input-dropdown.vue'
import AppSliderInput from '@/components/Slider-input.vue'
import VueSlider from 'vue-slider-component'
import 'vue-slider-component/theme/antd.css'
import { mapFields } from 'vuex-map-fields';
import { mapGetters } from 'vuex';
export default {

  name: 'app-step1',
  components: {
    AppInput,
    AppInputDropdown,
    VueSlider,
    AppSliderInput
  },
  created(){
  	this.$store.dispatch('getData');
  	
  },
  mounted(){
  	console.log(this.$route);

    const urlParams = new URLSearchParams(window.location.search);

    this.$store.commit('setPampaduClickId', urlParams.get('click_id') || '');
    this.$store.commit('setPampaduSubId', urlParams.get('sub_id') || '');
    this.$store.commit('setSalesChannel', urlParams.get('sales-channel') || '');
    this.$store.commit('setMentor', urlParams.get('mentor') || '');
    this.$store.commit('setAgent', urlParams.get('agent') || '');
  },
  data() {
  	return {
		searchQuery: '',
  	}
  },
  methods:{
	clearSelectedSports() {
      this.selectedSports = [];
    },
  	handleClick(){
  		this.$validator.validate().then(valid => {
        if (valid && this.selectedSports.length) {
           this.$router.push({name: 'step2'})
           this.$store.dispatch('setInsuredPeopleCount')
        }
      });
  	},
  	togglePopup(){
  		this.$store.commit('setPopupIsActive', !this.popupIsActive)
  		// this.popupIsActive = !this.popupIsActive;
  	},
  	selectSport(item) {
  		if(this.selectedSports.indexOf(item) == -1 && this.selectedSports.length < 5) {
  			this.selectedSports.push(item)
  		}
  		if(this.selectedSports.length >= 5) {
  			this.$store.commit('setPopupIsActive', !this.popupIsActive)
  		}
  	},
  	removeSport(item){
  		this.selectedSports.splice(this.selectedSports.indexOf(item), 1)
  	}
  },
  computed:{
	filteredSportList() {
      if (!this.searchQuery) {
        return this.sportList;
      }
      const lowerCaseQuery = this.searchQuery.toLowerCase();
      return this.sportList.filter(sport =>
        sport.UF_NAME.toLowerCase().includes(lowerCaseQuery)
      );
    },
  	getInputDescription(){
  		return this.sportList.slice(0,2);
  	},
  	selectedSportsNames(){
  		if(this.selectedSports.length) {
  			return this.selectedSports.map(item => ' ' + item.UF_NAME)
  		}
  	},
  	...mapFields([
	  'sportClubName',
      'termOptions',
      'countOptions',
      'sumOptions',
      // 'popupIsActive'
      'selectedSports',
      'totalCost'
    ]),
    ...mapGetters({
		  schema: 'getSchema',
		  popupIsActive: 'getPopupIsActive',
		  sportList: 'getSportList',
		  sportTariffs: 'getSportTariffs',
		})
  }
}
</script>

<style lang="scss">
.step__1desc {
	margin: 30px 0;
	font-size: 10px;
	color: #848199;
}
.suggestions-wrapper {
	position: relative;
	z-index: 10;
	
}
.suggestions-suggestions {
	background-color: #fff;
	cursor:pointer;
}
.input-desc {
	display: flex;
	align-items:center;
	margin-top: -2px;
	padding-left: 3px;
  
	&__title{
		font-size: 12px;
	  color: #808080;
		margin-right: 5px;
	}
	&__list {
		display: flex;
	}
	&__item{
		margin-right: 5px;
		&:last-child {
			margin-right: 0;
		}
		
	}
	&__link{
		color:#04a4b0;
		font-size: 12px;
		text-decoration: none;
	}
}
	.popup {
		background-color: #fff;
		// max-width: 50vw;
		// max-height: 50vh;
		
		
		border-radius:3px;
		position: relative;
		&__search {
		margin-bottom: 10px;
		position: relative;
		
		&-input {
			width: 100%;
			padding: 10px 15px;
			padding-left: 40px; // Отступ для иконки поиска
			border: 1px solid #e0e0e0;
			border-radius: 8px;
			box-sizing: border-box;
			font-size: 16px;
			color: #333;
			transition: border-color 0.3s ease;
			&:focus {
				outline: none;
				border-color: #1DB4C3; // Цвет при фокусе
			}
			&::placeholder {
				color: #999;
			}
		}
		&::before {
			content: "";
			position: absolute;
			left: 15px;
			top: 50%;
			transform: translateY(-50%);
			width: 20px;
			height: 20px;
			background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'%3E%3Cpath fill='%23999' d='M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z'/%3E%3C/svg%3E");
			background-repeat: no-repeat;
			background-size: contain;
			pointer-events: none; // Чтобы не мешала кликам
			}
		}
		&-overlay {
			display: flex;
			align-items:center;
			justify-content:center;
			z-index: 100;
			position: fixed;
			top: 0;
			left: 0;
			background-color: rgba(#000, .3);
			height: 100%;
			width: 100%;
		}
		&__inner {
			width: 900px;
			min-height: 500px;
			min-width: 320px;
			max-width: 50vw;
	    max-height: 50vh;
	    overflow-y:scroll;
	    padding: 20px 37px 60px 20px;
		}
		&__title {
			margin-bottom: 20px;
			color:#101b50;
			font-size: 24px;
		}
		&__list {
			// font-size: 0;
			padding-right: 50px;
			// white-space: nowrap;
		}
		&__button {
			display: flex;
			justify-content: flex-end;
			align-items: center;
			gap: 10px;
			position: absolute;
			right: 40px;
			bottom: 20px;
			&-elem {
				background-color: #1DB4C3;
		    color: #fff;
		    padding: 12px 28px 13px;
		    border-radius: 4px;
		    max-width: 300px;
		    width: 100%;
		    display: flex;
		    align-items: center;
		    justify-content: center;
		    border: 1px solid #04a4b0;
		    transition: .3s linear;
		    text-decoration: none;
		    font-size: 18px;
		    font-weight: 300;
		    outline: none;
		    cursor: pointer;
			&:hover {
				opacity: 0.8;
			}
			}
			
			&-clear {
			background-color: white;
			color: #1DB4C3;
			border: solid #1DB4C3 1px;

			padding: 12px 28px 13px;
			border-radius: 4px;
			max-width: 300px;
			width: 100%;
			display: flex;
			align-items: center;
			justify-content: center;
			transition: .3s linear;
			text-decoration: none;
			font-size: 18px;
			font-weight: 500;
			outline: none;
			cursor: pointer;
			&:hover {
				opacity: 0.8;
			}
		}
		}
		&__close {
			position: absolute;
			right: 20px;
			top: 20px;
			height: 20px;
			width:20px;
			cursor: pointer;
			transition:.2s;
			&:hover {
				transform:rotate(90deg);
			}
			&:before {
				content:'';
				display: block;
				background-color: $primary;
				height: 3px;
				width: 20px;
				position: absolute;
				right: 0px;
				top: 9px;
				transform:rotate(45deg);
			}
			&:after {
				content:'';
				display: block;
				background-color: $primary;
				height: 3px;
				width: 20px;
				position: absolute;
				right: 0px;
				top: 9px;
				transform:rotate(-45deg);
			}
		}
		&__remove {
			// position: absolute;
			height: 20px;
			width: 20px;
			display: none;
			right: -30px;
			cursor: pointer;
			// top: 2px;
			@include centered(y);
			&:before {
				content:'';
				display: block;
				background-color: $primary;
				height: 2px;
				width: 15px;
				position: absolute;
				right: 2px;
				top: 9px;
				transform:rotate(45deg);
			}
			&:after {
				content:'';
				display: block;
				background-color: $primary;
				height: 2px;
				width: 15px;
				position: absolute;
				right: 2px;
				top: 9px;
				transform:rotate(-45deg);
			}
		}
		&__item {
			margin-bottom: 10px;
			&:last-child {
				margin-bottom: 0;
			}
			&.active {
				.popup__link {
					background-color: $primary;
					color:#fff;
				}
				.popup__remove {
					display: block;
				}
			}
		}
		&__inner-item {
			position: relative;
			display: inline-block;
		}
		&__link {
			text-decoration: none;
			color:$primary;
			padding:3px 5px;
			border-radius: 9px;
			position: relative;
			display: inline-block;
			transition:.2s;

		}
	}
	.step {
		&__text-summ {
			display: none;
		}
		&__button-block {
			
		}
		&__desc {
	    width: 100%;
	    margin-top: 35px;
	    color: #808080;
	    font-size: 14px;
		}
		&__title {
			color:#101b50;
			font-size: 13px;
			margin-bottom: 20px;
			flex-direction: column;
			display: flex;
		}
		&__list {
			padding-right: 20px;
			display: flex;
			flex-direction: column;
			flex-wrap:wrap;
		}
		&__item {
			
			
			&:not(:last-child) {
				margin-bottom: 25px;
			}
			
			// align-items:center;
			&_large {
				width:100%;
		
			}
			&_small {
				width: calc(30% - 20px);
			}
			&_sports {

			}
			&-left {
				width: 42px;
				flex-shrink:0;
			}
			&-right {
				// width: calc(100% - 42px);
				flex:1;
				position: relative;
			}
		}
		&__pic {
			max-width: 100%;
			&-elem {
				display: block;
				margin:0 auto;
			}
		}
		&__button {
			padding-right: 20px;
			justify-content: flex-end;
			margin-top: 50px;
			display: flex;
		}
	padding: 30px;
	}
	.button {
		background-color: #1DB4C3;
		color:#fff;
		padding: 12px 28px 13px;
    border-radius: 10px;
		max-width: 300px;
		width: 100%;
		display: flex;
		align-items:center;
		justify-content:center;
		border:1px solid #04a4b0;
		transition:.3s linear;
		text-decoration: none;
		font-size: 20px;
		font-weight: 300;
		outline:none;
		cursor:pointer;
		&_type-simple {
			color: #1db4c0;
	    background-color: transparent;
	    border:none;
	    &:hover {
  	    color: #20c5d2;
		    background-color: transparent !important;
	    }
		}
		&.disabled {
			opacity: .5;
			&:hover {
				// background-color:$primary;
				// color:#fff;
			}
		}
		
		&:hover:not(.disabled) {
			// background-color: transparent;
			// color:#04a4b0;
	    background-color: #1aa3ae;
		}
	}
	@media (max-width: 524px) {
		.popup{
			&__button {
				justify-content: space-between;
				width: 100%;
				padding: 0 10px;
				left: 0;
			}
			&__inner {
				padding: 20px 20px 140px 20px;
			}
		}
	}

	@media (max-width: 1024px) {
		.popup {
			

		&__inner {
			max-height: 100vh;
			height: 100vh;
			min-width: 320px;
			max-width: 100vw;
		width: 100%;
	    overflow-y:scroll;
		}
		&__button {
			right: 10px;
			bottom: 60px;
		}
		&__title {
			margin-top: 60px;
		}
		&__close {
			top: 60px;
		}
	}
		.step {
			
			&__text-summ {
				display: block;
				text-align: center;
				margin: 25px 0;
				font-weight: 600;
				font-size: 17px;
			}
			&__button {
				padding: 0 30px 10px 30px;
				background-color: #cbeaed;
				display: flex;
				align-items: center;
				flex-direction: column;
				position: fixed;
				z-index: 10;
				bottom: 0;
				left: 0;
				width: 100%;
			}
			.button {
				font-weight: 500;
				font-size: 17px;
				padding: 7px ;
				min-height: 54px;
				max-width: 740px;
			}
		
			&__button-block {
				background-color: #cbeaed;
				display: flex;
				flex-direction: column;
				justify-content: center;
				align-items: center;
			
				width: 100%;
			}
	
		}
		
	}
</style>